var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6b0a78d1f503141376dfee57372ba16bd269288b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["frontend@distribute-e0"]={id:"6b0a78d1f503141376dfee57372ba16bd269288b"};
      